(() => {
  var GwpBanner = class extends HTMLElement {
    connectedCallback() {
      this.checkoutBtnElem = document.querySelector(".checkout-button");
      this.miniCartElem = document.getElementById("mini-cart");
      this.cartElem = document.getElementById("cart");
      this.isLoading = false;
      this.promo = {};
      this.variantId = null;
      this.countdownInterval = false;
      this._getGwpData();
    }

    setPromo(obj) {
      this.promo = obj;
    }

    initExpiration(totalSec) {
      const countDownDate = Cookies.get("promo-expiration");
      if (!countDownDate) {
        const cookieOptions = {};
        cookieOptions.expires = totalSec / 86400;
        Cookies.set(
          "promo-expiration",
          new Date().getTime() + totalSec * 1000,
          cookieOptions
        );
      }
    }

    setCountdown(promo, elems) {
      clearInterval(this.countdownInterval);
      const intervalFunc = () => {
        const countDownDate = Cookies.get("promo-expiration");
        if (!countDownDate) {
          const totalSec = promo.expire && promo.expire.total_sec ? promo.expire.total_sec : promo.expiration && promo.expiration.total_sec ? promo.expiration.total_sec : 0;	
          if (totalSec) {	
            this.initExpiration(totalSec);	
            return;	
          }
        }
        let now = new Date().getTime();
        if (!countDownDate) {
          return;
        }
        let distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        hours = hours < 10 ? "0" + hours : hours;
        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        elems.forEach((elem) => {
          elem.innerHTML = (days >= 1 ? days + ":" : "") + (hours === "00" ? "" : hours + ":") + minutes + ":" + seconds;
        });

        if (distance <= 0) {
          clearInterval(this.countdownInterval);
          elems.forEach((elem) => {
            elem.innerHTML = "00:00";
          });
        }
      }
      
      intervalFunc();
      this.countdownInterval = setInterval(intervalFunc, 1000);
      
    }

    async _getGwpData() {
      const url = new URL(window.location.href);
      const promoSlug =
        url.searchParams.get("promo") || Cookies.get("c_promo");

      if (promoSlug) {
        this._createBannerHTML(true);
      }

      const cartResponse = await fetch(
        `${window.themeVariables.routes.cartUrl}.js`
      );
      const cart = await cartResponse.json();
      if (window.themeVariables.settings.pageType === "cart" || window.location.pathname.includes("acquisition")) {
        this.hidden = true;
        if (!cart.total_price && cart.items.length > 0) {
          const clearCartResponse = await fetch(
            `${window.themeVariables.routes.cartClear}.js`
          );

          if (clearCartResponse.ok) {
            this._removeCookies(["promo_variant"]);
            if (window.themeVariables.settings.pageType === "cart") {
              window.location.href = "/cart";
            }
          }
        }
      }

      if (promoSlug) {
        const response = await fetch(
          `${window.themeVariables.routes.api}/gwp/${promoSlug}/`,
          {
            method: "GET",
          }
        );
        if (Cookies.get("promo_thank_you_page")) {
          this._removeCookies(["promo_thank_you_page"]);
        }
        const promo = await response.json();
        if (response.ok) {
          const cookieOptions = {};
          const totalSec = promo.expire && promo.expire.total_sec ? promo.expire.total_sec : promo.expiration && promo.expiration.total_sec ? promo.expiration.total_sec : 0;
          if (promo.slug !== Cookies.get("c_promo")) {
            localStorage.removeItem("gwpInited");
            this._removeCookies([
              "c_promo",
              "promo_variant",
              "promo-expiration",
            ]);

            localStorage.removeItem("gwp:temp");
            if (totalSec) {
              cookieOptions.expires = totalSec / 86400;
              Cookies.set(
                "promo-expiration",
                new Date().getTime() + totalSec * 1000,
                cookieOptions
              );
            } else {
              this._removeCookies(["promo-expiration"]);
            }
            Cookies.set("c_promo", promo.slug, cookieOptions);
          }
          this.setPromo(promo);
          if (totalSec) {
            this.initExpiration(totalSec);
          }
          const statusResponse = await fetch(
            `${window.themeVariables.routes.api}/gwp/status/?gwp_slug=${promo.slug}&cart_token=${cart.token}`,
            {
              method: "GET",
            }
          );

          const statusResponseJson = await statusResponse.json();
          let isValidGWP = false;
          if (statusResponse.ok) {
            if (statusResponseJson.valid) {
              isValidGWP = true;
            } else {
              if (
                statusResponseJson.reason !==
                "Cart with provided token wasn't found"
              ) {
                localStorage.removeItem("gwp:temp");
              }
            }
          }

          const info = {}, cookieVariant = Cookies.get("promo_variant");
          if (promo.shopify_product.variants.length === 1 &&
            promo.shopify_product.variants[0].available) {
              info.title = promo.shopify_product.variants[0].title;
              info.id = promo.shopify_product.variants[0].id;
          } else if (cookieVariant) {
            promo.shopify_product.variants.forEach((variant) => {
              if ('' + variant.id === cookieVariant && variant.available) {
                info.title = variant.title;
                info.id = variant.id;
              }
            });
          }

          if (window.themeVariables.settings.pageType === "cart") {
            this._createBanner(cart, promo);
          } else {
            if (
              info.id
            ) {
              if (!cart.items.length) {
                localStorage.setItem(
                  "gwp:temp",
                  JSON.stringify({
                    id: info.id,
                    title:
                      info.title ===
                      "Default Title"
                        ? "One size"
                        : info.title,
                  })
                );
                this._createBanner(cart, promo);
              } else {
                this.variantId = info.id;
                await this._addGwpToCart(
                  info.id,
                  cart,
                  promo
                );
              }
            } else {
              this._createBanner(cart, promo);
            }
          }
          if (!localStorage.getItem("gwpInited")) {
            const collapsibleContent = this.querySelector(
              "#gwp-banner-content"
            );
            collapsibleContent.setAttribute("open", true);
            localStorage.setItem("gwpInited", true);
          }
        } else {
          this.style.display = "none";
          this._removeCookies([
            "c_promo",
            "promo_variant",
            "promo-expiration",
          ]);
          localStorage.removeItem("gwpInited");
        }
      } else {
        this.style.display = "none";
        this._removeCookies(["promo_variant", "promo-expiration"]);
        localStorage.removeItem("gwpInited");
      }
      document.addEventListener("cart:render:end", (event) =>
        this._rerenderPromoContent(event)
      );
    }

    _removeCookies(cookiesArr) {
      cookiesArr.forEach((cookieName) => {
        Cookies.remove(cookieName);
      });
    }

    _createBannerHTML(loader) {
      this.innerHTML = `
        <div class="lpr-banner">
          <div class="lpr-header">
          <div class="lpr-container">
            <button class="lpr-header__outer lpr-collapsible-toggle" id="gwp-banner-top" aria-expanded="false" is="toggle-button" aria-controls="gwp-banner-content">
              ${
                loader
                  ? `<div class="lds-ring-wrapper"><div class="lds-ring"><div></div><div></div><div></div><div></div></div></div>`
                  : ""
              }
            </button>
            </div>
          </div>
          <collapsible-content animate-items="" id="gwp-banner-content" class="collapsible" style="overflow: visible;"></collapsible-content>
        </div>
      `;
      if (!window.location.pathname.includes("acquisition")) {
        this.removeAttribute('hidden');
      }
    }

    _setLoading(flag) {
      if (flag) {
        this.isLoading = true;
        this.setAttribute("loading", true);
        if (this.checkoutBtnElem) {
          this.checkoutBtnElem.setAttribute("disabled", true);
        }
      } else {
        this.isLoading = false;
        this.removeAttribute("loading");
        if (this.checkoutBtnElem) {
          this.checkoutBtnElem.removeAttribute("disabled");
        }
      }
    }

    _setVariantToCookie(id, promo) {
      const cookieOptions = {};
      const totalSec = promo.expire && promo.expire.total_sec ? promo.expire.total_sec : promo.expiration && promo.expiration.total_sec ? promo.expiration.total_sec : 0;
      if (totalSec) {
        cookieOptions.expires = totalSec / 86400;
      } else {
        if (Cookies.get("promo-expiration")) {
          cookieOptions.expires = new Date(+Cookies.get("promo-expiration"));
        }
      }
      Cookies.set("promo_variant", id, cookieOptions);
    }

    async _addGwpToCart(id, cart, promo) {
      this._setLoading(true);
      const formData = {
        items: [
          {
            id: id,
            quantity: 1,
            properties: {
              // '_type': 'gwp',
              // '_promo': GwpModule.getPromo().slug
              ["_Offer type"]: "GWP",
              ["_Gift code"]: promo.slug,
            },
          },
        ],
      };

      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties && item.properties["_Offer type"] === "GWP") {
          updates[item.id] = 0;
        }
      });

      if (
        updates &&
        Object.keys(updates).length !== 0 &&
        Object.getPrototypeOf(updates) === Object.prototype
      ) {
        const updateCartResponse = await fetch(
          `${window.themeVariables.routes.cartUpdate}.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
          }
        );
        if (updateCartResponse.ok) {
          this._removeCookies(["promo_variant"]);
        }
      }

      const response = await fetch(
        `${window.themeVariables.routes.cartAddUrl}.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const responseJson = await response.json();
      if (response.ok) {
        await fetch(`${window.themeVariables.routes.cartUrl}.js`).then(
          async (response2) => {
            const cartContent = await response2.json();
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:updated", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                },
              })
            );
            cartContent["sections"] = responseJson["sections"];
            document.documentElement.dispatchEvent(
              new CustomEvent("cart:refresh", {
                bubbles: true,
                detail: {
                  cart: cartContent,
                },
              })
            );
            this._setVariantToCookie(id, promo);
            if (window.themeVariables.settings.pageType === "cart") {
              window.location.href = "/cart";
              return;
            }
            this._createBanner(cartContent, promo, true);
          }
        );
      } else {
        const url = new URL(window.location.href);
        const promoSlug =
          url.searchParams.get("promo") || Cookies.get("c_promo");
        if (promoSlug) {
          const response = await fetch(
            `${window.themeVariables.routes.api}/gwp/${promoSlug}/`,
            {
              method: "GET",
            }
          );
          const promo = await response.json();
          if (response.ok) {
            this.promo = promo;
            this._createBanner(cart, promo);
          }
        }
        console.error(response.message);
      }
    }

    async _updateAndRefreshCart(responseJson) {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:updated", {
          bubbles: true,
          detail: {
            cart: responseJson,
          },
        })
      );
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
          detail: {
            cart: responseJson,
          },
        })
      );
    }

    async _rerenderPromoContent(event) {
      if (
        !event.detail.cart.total_price &&
        event.detail.cart.items.length > 0
      ) {
        this._setLoading(true);
        const clearCartResponse = await fetch(
          `${window.themeVariables.routes.cartClear}.js`
        );
        const cart = await clearCartResponse.json();

        if (clearCartResponse.ok) {
          this._removeCookies(["promo_variant"]);
          this.variantId = null;

          await this._updateAndRefreshCart(cart);
          if (window.themeVariables.settings.pageType === "cart") {
            window.location.href = "/cart";
          }
        }
        this._setLoading(false);
      } else {
        if (
          event.detail.cart.items.length &&
          localStorage.getItem("gwp:temp")
        ) {
          const gwpInfo = JSON.parse(localStorage.getItem("gwp:temp"));

          await this._addGwpToCart(
            +gwpInfo.id,
            event.detail.cart,
            this.promo
          );
          localStorage.removeItem("gwp:temp");
          return;
        } else {
          this._createBanner(event.detail.cart, this.promo);
        }
      }
    }

    async _updateGWPInCart(props) {
      return await fetch(`${window.themeVariables.routes.cartUpdate}.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: props }),
      });
    }

    async addGwpToCartHandler(e, promo, cart, flag) {
      if (this.isLoading) {
        return;
      }

      const messageElement = this.querySelector(".cart-gwp-message");
      messageElement.innerHTML = "";
      messageElement.style.setProperty("display", "none");

      let isVariantAvailabled = false,
        title = "";
      promo.shopify_product.variants.forEach((variant) => {
        if (variant.id === +e.target.value && variant.available) {
          isVariantAvailabled = true;
          title = variant.title;
        }
      });

      if (isVariantAvailabled) {
        if (!cart.items.length) {
          localStorage.setItem(
            "gwp:temp",
            JSON.stringify({ id: e.target.value, title })
          );
          if (flag) {
            this._createBanner(cart, promo);
          }
        } else {
          this.variantId = +e.target.value;

          await this._addGwpToCart(e.target.value, cart, promo);
        }
      } else {
        messageElement.innerHTML = "Sold out";
        messageElement.style.setProperty("display", "block");
      }
    }

    async _createBanner(cart, promo) {
      if (promo.slug) {
        this._setLoading(true);
        let isNotValidQuantity = false,
          isCurrentAvailabled = false,
          isSomeAvailabled = false,
          chosenVariant = "";
        if (localStorage.getItem("gwp:temp")) {
          const gwpInfo = JSON.parse(localStorage.getItem("gwp:temp"));
          chosenVariant = gwpInfo.title;
        }
        const updates = {};

        const isGWPInCart = cart.items.length
          ? cart.items.some((item) => {
              let isVariantExist = false;
              promo.shopify_product.variants.forEach((variant) => {
                if (variant.id === item.id) {
                  isVariantExist = true;

                  chosenVariant =
                    variant.title === "Default Title"
                      ? "One size"
                      : variant.title;
                  if (item.quantity > 1) {
                    isNotValidQuantity = true;
                  }
                  if (variant.available) {
                    isCurrentAvailabled = true;
                    this.variantId = variant.id;
                  } else {
                    this._removeCookies(["promo_variant"]);
                  }
                }
              });
              return isVariantExist;
            })
          : false;

        if (!isGWPInCart && Cookies.get("promo_variant")) {
          this._removeCookies(["promo_variant"]);
          this.variantId = null;
        }

        const currentVariant = this.variantId || Cookies.get("promo_variant");
        let isValidGWP = false,
          reason = "";

        if (isNotValidQuantity && isGWPInCart) {
          const updateCartResponse = await this._updateGWPInCart({
            [currentVariant]: 1,
          });
          const updateCartResponseJson = await updateCartResponse.json();
          if (updateCartResponse.ok) {
            await this._updateAndRefreshCart(updateCartResponseJson);
            if (window.themeVariables.settings.pageType === "cart") {
              window.location.href = "/cart";
            }
            return;
          }
        }

        const currentGwps = [];
        cart.items.forEach((item) => {
          if (item.properties && item.properties["_Offer type"] === "GWP") {
            currentGwps.push(item);
          }
        });

        if (currentGwps.length > 1) {
          const updates = {};
          currentGwps.forEach((gwp, ind) => {
            if (!ind) {
              updates[gwp.id] = 0;
            }
          });
          const updateCartResponse = await this._updateGWPInCart(updates);
          const updateCartResponseJson = await updateCartResponse.json();
          if (updateCartResponse.ok) {
            await this._updateAndRefreshCart(updateCartResponseJson);
            if (window.themeVariables.settings.pageType === "cart") {
              window.location.href = "/cart";
            }
            return;
          }
        }

        if (!isCurrentAvailabled && isGWPInCart) {
          const updateCartResponse = await this._updateGWPInCart({
            [currentVariant]: 0,
          });
          const updateCartResponseJson = await updateCartResponse.json();
          if (updateCartResponse.ok) {
            await this._updateAndRefreshCart(updateCartResponseJson);
            if (window.themeVariables.settings.pageType === "cart") {
              window.location.href = "/cart";
            }
            return;
          }
        }

        if (!Cookies.get("promo_variant") && this.variantId) {
          this._setVariantToCookie(currentVariant, promo);
        }

        const statusResponse = await fetch(
          `${window.themeVariables.routes.api}/gwp/status/?gwp_slug=${promo.slug}&cart_token=${cart.token}`,
          {
            method: "GET",
          }
        );

        const statusResponseJson = await statusResponse.json();

        if (statusResponse.ok) {
          if (statusResponseJson.valid) {
            isValidGWP = true;
          } else {
            this._removeCookies(["promo_variant"]);
            if (isGWPInCart) {
              const updateCartResponse = await this._updateGWPInCart({
                [currentVariant]: 0,
              });
              const updateCartResponseJson = await updateCartResponse.json();
              if (updateCartResponse.ok) {
                await this._updateAndRefreshCart(updateCartResponseJson);
                if (window.themeVariables.settings.pageType === "cart") {
                  window.location.href = "/cart";
                }
                return;
              }
            }

            if (
              statusResponseJson.reason ===
              "Cart with provided token wasn't found"
            ) {
              isValidGWP = true;
            } else if (statusResponseJson.reason === "GWP is inactive") {
              reason = "This item is no longer available";
            } else if (statusResponseJson.reason === "Cart needs to have more items or to have more total amount") {
              reason = "";
            } else {
              isValidGWP = false;
              reason = statusResponseJson.reason;
            }
          }
        }

        this._setLoading(false);
        let variantItemElements = "";
        let isCurrentVariantExist = false;

        if (promo.shopify_product.variants.length === 1) {
          variantItemElements += `
            <label class="block-swatch${
              !promo.shopify_product.variants[0].available
                ? " is-disabled"
                : ""
            }">
              <input class="block-swatch__radio visually-hidden" id="${`variant-item-${promo.shopify_product.variants[0].title}`}" type="radio" name="gwp_variant" value="${
            promo.shopify_product.variants[0].id
          }">
              <span class="block-swatch__item">Add to cart</span>
            </label>
          `;
          if (promo.shopify_product.variants[0].id === +currentVariant) {
            isCurrentVariantExist = true;
          }
        } else {
          promo.shopify_product.variants.forEach((variant) => {
            variantItemElements += `
              <label class="block-swatch${
                !variant.available ? " is-disabled" : ""
              }">
                <input class="block-swatch__radio visually-hidden" id="${`variant-item-${variant.title}`}" type="radio" name="gwp_variant" value="${
              variant.id
            }">
                <span class="block-swatch__item">${variant.title}</span>
              </label>
            `;
            if (variant.id === +currentVariant) {
              isCurrentVariantExist = true;
            }
          });
        }

        if (!isCurrentVariantExist) {
          this._removeCookies(["promo_variant"]);
        }

        const tempGwpId = localStorage.getItem("gwp:temp");

        promo.shopify_product.variants.forEach((variant) => {
          if (variant.available) {
            isSomeAvailabled = true;
          }
        });

        const selector = `<div class="cart-gwp-wrapper__selector">
            ${
              !isGWPInCart && isValidGWP && isSomeAvailabled && !tempGwpId
                ? `<div class="cart-gwp-selector-wrapper">
                  ${
                    promo.shopify_product.variants.length > 1
                      ? promo.shopify_product.variants[0].title === "5" || (promo.shopify_product.variants[0].option1 && promo.shopify_product.variants[0].option1.toLowerCase().includes("ring"))
                        ? '<strong class="cart-gwp-selector-wrapper__title">Select a ring size to add this free gift to your cart:</strong>'
                        : '<strong class="cart-gwp-selector-wrapper__title">Select a variant to add this free gift to your cart:</strong>'
                      : ""
                  }
                  <div class="block-swatch-list cart-gwp-selector-list${
                    (promo.shopify_product.variants.length > 1 &&
                    promo.shopify_product.variants[0].title === "5") || (promo.shopify_product.variants[0].option1 && promo.shopify_product.variants[0].option1.toLowerCase().includes("ring"))
                      ? " block-swatch-list-rs"
                      : ""
                  }">
                    ${variantItemElements}
                  </div>
                </div>`
                : ""
            }
          </div>
          <div class="cart-gwp-message" style="display: none;"></div>
          ${
            !isValidGWP && isSomeAvailabled && reason
              ? `<div class="cart-gwp-message">${reason}</div>`
              : ""
          }
          
          ${
            !isSomeAvailabled
              ? `<div class="cart-gwp-message">Unfortunately, this product is out of stock.</div>`
              : ""
          }`;

          const totalSec = promo.expire && promo.expire.total_sec ? promo.expire.total_sec : promo.expiration && promo.expiration.total_sec ? promo.expiration.total_sec : 0;

        const bannerTop = `<div class="lpr-header__inner">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99999 6.64463e-07C5.11594 6.64463e-07 4.26809 0.35119 3.64297 0.97631C3.01785 1.60143 2.66666 2.44928 2.66666 3.33333V3.71466C2.66666 4.312 2.844 4.868 3.14933 5.33333H2C1.46957 5.33333 0.960858 5.54404 0.585786 5.91911C0.210713 6.29419 0 6.80289 0 7.33333V8.66666C0 9.19709 0.210713 9.7058 0.585786 10.0809C0.960858 10.4559 1.46957 10.6667 2 10.6667H9.33332V5.33333H10.6667V10.6667H18C18.5304 10.6667 19.0391 10.4559 19.4142 10.0809C19.7893 9.7058 20 9.19709 20 8.66666V7.33333C20 6.80289 19.7893 6.29419 19.4142 5.91911C19.0391 5.54404 18.5304 5.33333 18 5.33333H16.8507C17.156 4.868 17.3333 4.312 17.3333 3.71466V3.33333C17.3333 2.44928 16.9821 1.60143 16.357 0.97631C15.7319 0.35119 14.884 6.64463e-07 14 6.64463e-07C12.3027 6.64463e-07 10.816 0.906666 9.99999 2.26133C9.58518 1.57118 8.99875 1.00017 8.29779 0.603896C7.59683 0.207619 6.80522 -0.000429097 5.99999 6.64463e-07ZM10.6667 5.33333H14.3813C15.2747 5.33333 16 4.608 16 3.71466V3.33333C16 2.8029 15.7893 2.29419 15.4142 1.91912C15.0391 1.54405 14.5304 1.33333 14 1.33333C13.1159 1.33333 12.2681 1.68452 11.643 2.30964C11.0178 2.93476 10.6667 3.78261 10.6667 4.66666V5.33333ZM9.33332 5.33333H5.61866C4.72533 5.33333 4 4.608 4 3.71466V3.33333C4 2.8029 4.21071 2.29419 4.58578 1.91912C4.96085 1.54405 5.46956 1.33333 5.99999 1.33333C6.43773 1.33333 6.87119 1.41955 7.2756 1.58707C7.68002 1.75458 8.04749 2.00011 8.35701 2.30964C8.66654 2.61917 8.91207 2.98663 9.07959 3.39105C9.24711 3.79547 9.33332 4.22892 9.33332 4.66666V5.33333Z" fill="#FDFBF9"/>
                <path d="M9.33341 12H1.33341V16.6667C1.33341 17.5507 1.6846 18.3986 2.30972 19.0237C2.93484 19.6488 3.78269 20 4.66674 20H9.33341V12Z" fill="#FDFBF9"/>
                <path d="M10.6667 20H15.3334C16.2174 20 17.0653 19.6488 17.6904 19.0237C18.3155 18.3986 18.6667 17.5507 18.6667 16.6667V12H10.6667V20Z" fill="#FDFBF9"/>
              </svg>

              <div class="lpr-header__info">
                <span id="lpr-header__title" class="lpr-header__title">${
                  isGWPInCart && isValidGWP
                    ? "FREE GIFT ACTIVATED"
                    : "CLAIM YOUR FREE GIFT"
                }</span>
                ${
                  totalSec && totalSec > 0 && isValidGWP && isSomeAvailabled
                    ? `<div class="lpr-countdown__top">${
                        promo.label_text_option === "Expires In"
                          ? "Expires in"
                          : promo.label_text_option === "Reserved For"
                          ? "Reserved for"
                          : promo.label_text_option
                      }&nbsp;<span class="gwp-countdown">Loading...</span></div>`
                    : ""
                }
              </div>
          </div>
          <div class="lpr-header__icon">
            <svg width="14" height="8" viewBox="0 0 14 8" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13 7L7 1L1 7" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>`;

      const bannerContent = `
      <div class="lpr-body">
        <div class="lpr-box">
            <div class="lpr-box__img-wrapper">
            <div class="lpr-box__img-wrapper-inner">
                <img src="${
                  promo.popup
                    ? promo.popup.image
                    : promo.shopify_product.image_link
                }" alt="${promo.title}" />
            </div>
            </div>
            <div class="lpr-box__info">
            ${
              totalSec && totalSec > 0 && isValidGWP && isSomeAvailabled
                ? `<div class="lpr-countdown">${promo.label_text_option}&nbsp;<span class="gwp-countdown">Loading...</span></div>`
                : ""
            }
            <h3 class="lpr-box__title">${promo.title}</h3>
            ${
              chosenVariant
                ? `<div class="lpr-box__current-variant">
                <p>${
                  (promo.shopify_product.variants.length > 1 &&
                  promo.shopify_product.variants[0].title === "5") || (promo.shopify_product.variants[0].option1 && promo.shopify_product.variants[0].option1.toLowerCase().includes("ring"))
                    ? "Ring size: "
                    : ""
                }${chosenVariant}</p>
              </div>`
                : ""
            }
            <div class="lpr-cart-gwp-wrapper cart-gwp-wrapper__selector-holder cart-gwp-wrapper__selector-holder_dt">
              ${selector}
            </div>
            ${
              chosenVariant && isValidGWP
                ? `<div class="lpr-footer-check lpr-footer-check_dt">
              <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 3.30739L4.46154 6.76893L10 1.23047" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="lpr-footer-check__text">APPLIED</span>
            </div>`
                : ""
            }
          </div>
        </div>

        <div class="lpr-cart-gwp-wrapper cart-gwp-wrapper__selector-holder cart-gwp-wrapper__selector-holder_mb">
          ${selector}
        </div>
          
        </div>
        <div class="lpr-footer">
          <div class="lpr-footer-inner${
            chosenVariant ? " lpr-footer-inner_check" : ""
          }">
            ${promo.requirements ? `<p>${promo.requirements}</p>` : ""}
            ${
              chosenVariant && isValidGWP
                ? `<div class="lpr-footer-check lpr-footer-check_mb">
              <svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 3.30739L4.46154 6.76893L10 1.23047" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span class="lpr-footer-check__text">APPLIED</span>
            </div>`
                : ""
            }
          </div>
        </div>
      `;

        document.documentElement.dispatchEvent(
          new CustomEvent("gwp:banner:updated", {
            bubbles: true,
            detail: {
              isValidGWP,
              isSomeAvailabled,
              reason,
              tempGwpId,
              variantItemElements,
              promo,
              cart,
              isGWPInCart,
            },
          })
        );

        const bannerTopElem = this.querySelector("#gwp-banner-top"),
          bannerContentElem = this.querySelector("#gwp-banner-content");

        if (bannerTopElem) {
          bannerTopElem.innerHTML = bannerTop;
        }

        if (bannerContentElem) {
          bannerContentElem.innerHTML = bannerContent;
        }

        if (totalSec && totalSec > 0 && isValidGWP) {
          this.setCountdown(promo, document.querySelectorAll(".gwp-countdown"));
        }

        const bannerInputs = this.querySelectorAll(
          'input[name="gwp_variant"]'
        );
        if (bannerInputs) {
          bannerInputs.forEach((elem) => {
            elem.addEventListener("change", (event) =>
              this.addGwpToCartHandler(event, promo, cart, true)
            );
          });
        }
      }
    }
  };
  window.customElements.define("gwp-banner", GwpBanner);

  var CartGwp = class extends GwpBanner {
    connectedCallback() {
      document.addEventListener("gwp:banner:updated", (event) =>
        this._createGwpContent(event)
      );
    }

    async _createGwpContent(event) {
      const {
        isValidGWP,
        isSomeAvailabled,
        reason,
        tempGwpId,
        variantItemElements,
        promo,
        cart,
        isGWPInCart,
      } = event.detail;

      if (isGWPInCart || window.location.pathname.includes("acquisition")) {
        this.innerHTML = "";
        return;
      }

      const totalSec = promo.expire && promo.expire.total_sec ? promo.expire.total_sec : promo.expiration && promo.expiration.total_sec ? promo.expiration.total_sec : 0;

      if (promo.slug && promo.is_active) {
        this.innerHTML = `
          <div id="cart-gwp-wrapper" class="cart-gwp-wrapper">
            <div class="cart-gwp-header">
              <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" class="cart-gwp-header__icon">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.49999 6.64463e-07C5.61594 6.64463e-07 4.76809 0.35119 4.14297 0.97631C3.51785 1.60143 3.16666 2.44928 3.16666 3.33333V3.71466C3.16666 4.312 3.344 4.868 3.64933 5.33333H2.5C1.96957 5.33333 1.46086 5.54404 1.08579 5.91911C0.710713 6.29419 0.5 6.80289 0.5 7.33333V8.66666C0.5 9.19709 0.710713 9.7058 1.08579 10.0809C1.46086 10.4559 1.96957 10.6667 2.5 10.6667H9.83332V5.33333H11.1667V10.6667H18.5C19.0304 10.6667 19.5391 10.4559 19.9142 10.0809C20.2893 9.7058 20.5 9.19709 20.5 8.66666V7.33333C20.5 6.80289 20.2893 6.29419 19.9142 5.91911C19.5391 5.54404 19.0304 5.33333 18.5 5.33333H17.3507C17.656 4.868 17.8333 4.312 17.8333 3.71466V3.33333C17.8333 2.44928 17.4821 1.60143 16.857 0.97631C16.2319 0.35119 15.384 6.64463e-07 14.5 6.64463e-07C12.8027 6.64463e-07 11.316 0.906666 10.5 2.26133C10.0852 1.57118 9.49875 1.00017 8.79779 0.603896C8.09683 0.207619 7.30522 -0.000429097 6.49999 6.64463e-07ZM11.1667 5.33333H14.8813C15.7747 5.33333 16.5 4.608 16.5 3.71466V3.33333C16.5 2.8029 16.2893 2.29419 15.9142 1.91912C15.5391 1.54405 15.0304 1.33333 14.5 1.33333C13.6159 1.33333 12.7681 1.68452 12.143 2.30964C11.5178 2.93476 11.1667 3.78261 11.1667 4.66666V5.33333ZM9.83332 5.33333H6.11866C5.22533 5.33333 4.5 4.608 4.5 3.71466V3.33333C4.5 2.8029 4.71071 2.29419 5.08578 1.91912C5.46085 1.54405 5.96956 1.33333 6.49999 1.33333C6.93773 1.33333 7.37119 1.41955 7.7756 1.58707C8.18002 1.75458 8.54749 2.00011 8.85701 2.30964C9.16654 2.61917 9.41207 2.98663 9.57959 3.39105C9.74711 3.79547 9.83332 4.22892 9.83332 4.66666V5.33333Z" fill="#FDFBF9"/>
                <path d="M9.83341 12H1.83341V16.6667C1.83341 17.5507 2.1846 18.3986 2.80972 19.0237C3.43484 19.6488 4.28269 20 5.16674 20H9.83341V12Z" fill="#FDFBF9"/>
                <path d="M11.1667 20H15.8334C16.7174 20 17.5653 19.6488 18.1904 19.0237C18.8155 18.3986 19.1667 17.5507 19.1667 16.6667V12H11.1667V20Z" fill="#FDFBF9"/>
              </svg>
              <strong id="cart-gwp-wrapper__header">${
                isGWPInCart && isValidGWP
                  ? "FREE GIFT ACTIVATED"
                  : "CLAIM YOUR FREE GIFT"
              }</strong>
            </div>
            ${
              totalSec && totalSec > 0 && isValidGWP && isSomeAvailabled
                ? `<div class="cart-gwp-counter">${promo.label_text_option}&nbsp;<span class="gwp-countdown">Loading...</span></div>`
                : ""
            }
            <div class="cart-gwp-body">
                <div class="cart-gwp-info">
                  <div class="cart-gwp-info__img-wrapper">
                    <img id="cart-gwp-wrapper__image" src="${
                      promo.popup
                        ? promo.popup.image
                        : promo.shopify_product.image_link
                    }" alt="${promo.title}" />
                  </div>
                  <div class="cart-gwp-info__description">
                    <div class="cart-gwp-info__description-part">
                        <h3 class="cart-gwp-info__title cart-gwp__priority-text" id="cart-gwp-wrapper__title">${
                          promo.title
                        }</h3>
                        <div class="cart-gwp-info__post-title">
                          <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 5px; min-width: 14px;">
                            <path d="M13.3102 7.17823C13.5645 6.92396 13.7074 6.57907 13.7075 6.21942L13.7075 1.35617C13.7075 0.996495 13.5646 0.651546 13.3103 0.397214C13.056 0.142882 12.711 -4.35582e-08 12.3513 -5.92803e-08L7.4881 -2.71859e-07C7.12845 7.65226e-05 6.78356 0.143009 6.52929 0.397359L1.10459 5.82206C0.850346 6.07638 0.70752 6.42126 0.70752 6.78087C0.70752 7.14048 0.850346 7.48537 1.10459 7.73969L5.96783 12.6029C6.22215 12.8572 6.56704 13 6.92665 13C7.28626 13 7.63114 12.8572 7.88546 12.6029L13.3102 7.17823ZM8.96091 3.39044C8.961 3.03067 9.104 2.68567 9.35846 2.43134C9.61292 2.177 9.95799 2.03417 10.3178 2.03426C10.6775 2.03435 11.0225 2.17736 11.2769 2.43182C11.5312 2.68627 11.674 3.03134 11.6739 3.39111C11.6738 3.75088 11.5308 4.09588 11.2764 4.35021C11.0219 4.60455 10.6769 4.74738 10.3171 4.74729C9.95731 4.7472 9.61231 4.60419 9.35798 4.34974C9.10365 4.09528 8.96082 3.75021 8.96091 3.39044Z" fill="#262626"/>
                          </svg>
                          <span class="cart-gwp__text">Free gift ${
                            promo.shopify_product.variants[0].compare_at_price
                              ? `<span id="cart-gwp-wrapper__price">(-$${promo.shopify_product.variants[0].compare_at_price})</span>`
                              : ""
                          }</span>
                        </div>
                    </div>
                    <div class="cart-gwp-info__description-part"></div>
                  </div>
                </div>
                  <div class="cart-gwp-wrapper__selector">
                    ${
                      !isGWPInCart && isValidGWP && isSomeAvailabled
                        ? `<div class="cart-gwp-selector-wrapper">
                      ${
                        promo.shopify_product.variants.length > 1
                          ? promo.shopify_product.variants[0].title === "5" || (promo.shopify_product.variants[0].option1 && promo.shopify_product.variants[0].option1.toLowerCase().includes("ring"))
                            ? '<strong class="cart-gwp-selector-wrapper__title">Select a ring size to add this free gift to your cart:</strong>'
                            : '<strong class="cart-gwp-selector-wrapper__title">Select a variant to add this free gift to your cart:</strong>'
                          : ""
                      }
                      <div class="block-swatch-list cart-gwp-selector-list${
                        (promo.shopify_product.variants.length > 1 &&
                        promo.shopify_product.variants[0].title === "5") || (promo.shopify_product.variants[0].option1 && promo.shopify_product.variants[0].option1.toLowerCase().includes("ring"))
                          ? " block-swatch-list-rs"
                          : ""
                      }">
                        ${variantItemElements}
                      </div>
                    </div>`
                        : ""
                    }
                </div>
                <div class="cart-gwp-message" style="display: none;"></div>
                ${
                  !isValidGWP && isSomeAvailabled
                    ? `<div class="cart-gwp-message">${reason}</div>`
                    : ""
                }
                ${
                  !isSomeAvailabled
                    ? `<div class="cart-gwp-message">Unfortunately, this product isn't availabled.</div>`
                    : ""
                }
            </div>
          </div>`;

        if (totalSec && totalSec > 0) {
          this.setCountdown(promo, document.querySelectorAll(".gwp-countdown"));
        }

        const cartInputs = this.querySelectorAll('input[name="gwp_variant"]');

        if (cartInputs) {
          cartInputs.forEach((elem) => {
            elem.addEventListener("change", (event) =>
              this.addGwpToCartHandler(event, promo, cart)
            );
          });
        }
      } else {
        this.innerHTML = ``;
      }
    }
  };
  window.customElements.define("cart-gwp", CartGwp);
})();